import Error from "./views/Error/Error";
import { lazy, Suspense } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import Login from "./views/Login/Login";
import AppLayout from "./views/AppLayout/AppLayout";
import Home from "./views/Home/Home";
import BrokerOnboard from "./views/BrokerOnboard/BrokerOnboard";
// import DashBoard from "./views/Dashboard/Dashboard";
import ProtectedRoute from "./views/RouteLayouts/ProtectedRouteLayout";
import PublicRoute from "./views/RouteLayouts/PublicRouteLayout";

const Equity = lazy( () => import("./views/Equity/Equity"));       //lazyly loaded components

const router = createBrowserRouter([
    {
        element: <PublicRoute />,
        children: [
            {
                path: "/",
                element: <Login />,
                errorElement: <Error />
            }
        ]
    },
    {
        element: <ProtectedRoute />,
        children: [
            {
                path: "/app",
                element: <AppLayout />,
                children : [
                    {
                        path: "home",
                        element: <Home />
                    },
                    {
                        path: "broker-onboard",
                        element: <BrokerOnboard />
                    },
                    {
                        path: "equity",
                        element: <Equity />
                        // element: <Suspense fallback={<div>Loading...</div>} > <Equity /> </Suspense>
                    },
                ]
            }
        ]
    }
]);

export default router;